var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import KnockoutModel from "../../lib/knockout_model";
import { Page } from "../../lib/page-component";
import * as authorization from "../../lib/authorization";
import "./login.css";
import MD5 from "../../app-lib/md5";
var MyModel = /** @class */ (function (_super) {
    __extends(MyModel, _super);
    function MyModel(root) {
        var _this = 
        // 发送请求
        _super.call(this, "/api/AccessToken", root) || this;
        var vm = {
            Username: ko.observable(''),
            Password: ko.observable(),
            rememberMe: false
        };
        _this.viewModel(vm);
        return _this;
    }
    // onValidating(d: any) {
    //     let viewModel = d;
    //     if (!viewModel.Username) {
    //         //window.popBox.show("请输入用户名");
    //         console.log("请输入用户名");
    //         return "请输入用户名。";
    //     }
    //     if (!viewModel.Password()) {
    //         //window.popBox.show("请输入密码");
    //         console.log("请输入密码。");
    //         return "请输入密码。";
    //     }
    //     return "";
    // }
    // 提交点击事件函数 
    MyModel.prototype.save = function () {
        var viewModel = this.viewModel();
        if (viewModel.Username().trim() == "") {
            window.popBox.show("请输入用户名");
            // console.log("请输入用户名");
            return "请输入用户名。";
        }
        if (!viewModel.Password()) {
            window.popBox.show("请输入密码");
            // console.log("请输入密码。");
            return "请输入密码。";
        }
        //进行md5的加密
        var md5 = new MD5();
        viewModel.Password(md5.hex_md5(viewModel.Password()));
        //console.log();
        this.saveData(viewModel).then(function (d) {
            if (d == false || !d.data) {
                return window.popBox.show(d.message); // token
            }
            //userId
            viewModel.Username("");
            viewModel.Password("");
            window.localStorage.setItem('indexPage', d.data.indexPage);
            window.localStorage.setItem('infomationPool', d.data.infomationPool);
            window.localStorage.setItem('projectNotice', d.data.projectNotice);
            window.localStorage.setItem('fileSystem', d.data.fileSystem);
            window.localStorage.setItem('userDaily', d.data.userDaily);
            window.localStorage.setItem('systemSetting', d.data.systemSetting);
            window.localStorage.setItem('img', d.data.img);
            window.localStorage.setItem('role', d.data.role);
            var lastLoginTime = d.data.LastLogin.substring(0, d.data.LastLogin.length - 9).replace("T", " ");
            window.localStorage.setItem('0', lastLoginTime);
            window.localStorage.setItem('1', lastLoginTime);
            window.localStorage.setItem('2', lastLoginTime);
            window.localStorage.setItem('3', lastLoginTime);
            window.localStorage.setItem('4', lastLoginTime);
            window.localStorage.setItem('5', lastLoginTime);
            window.localStorage.setItem('6', lastLoginTime);
            window.localStorage.setItem('7', lastLoginTime);
            window.localStorage.setItem("popur", '1');
            authorization.login(d.data.userId, d.data.nickname, d.data.token);
            //  author 刘云哲 保存上一次登入的事件
        });
    };
    return MyModel;
}(KnockoutModel));
var MyViewModel = /** @class */ (function (_super) {
    __extends(MyViewModel, _super);
    function MyViewModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasLayout = false;
        return _this;
    }
    MyViewModel.prototype.init = function () {
        this.c = new MyModel(this.container);
        this.c.bind();
    };
    MyViewModel.prototype.update = function (arg) {
        // if(arg.routeData.query.userId&&arg.routeData.query.token){
        //     window.localStorage.removeItem('UserId');
        //     window.localStorage.removeItem('AccessToken');
        //     window.localStorage.removeItem('Username');
        //     console.log('手动登出成功');
        //     this.c.dd(arg.routeData.query);
        // }else{
        //     this.c.dd(undefined);
        // }
        // console.log('获取到登录值为：'+ this.c.toJS(this.c.dd()))
        //return <any>this.c.isLogin();
        return Promise.resolve();
    };
    MyViewModel.prototype.onInitComplete = function () {
        console.log('22');
    };
    return MyViewModel;
}(Page));
export default MyViewModel;
